import type { Location } from 'react-router-dom';
import { ROUTES } from './constants';

export interface AuthRedirectState {
  from?: Location;
}

const RUTAS_CREACION_EMPRESA = [
  '/configuracion/empresa/crear',
  '/configuracion/empresa/create',
];

export function esRutaCreacionEmpresa(pathname: string): boolean {
  return RUTAS_CREACION_EMPRESA.some(
    (ruta) => pathname === ruta || pathname.startsWith(`${ruta}/`),
  );
}

export function resolverRutaAuthNoAutenticado(pathname: string): string {
  return esRutaCreacionEmpresa(pathname) ? ROUTES.PUBLIC.REGISTER : ROUTES.PUBLIC.LOGIN;
}

export function resolverDestinoAuth(state: unknown, fallback: string): string {
  const from = (state as AuthRedirectState | null)?.from;
  if (!from?.pathname || !from.pathname.startsWith('/')) return fallback;
  return `${from.pathname}${from.search ?? ''}${from.hash ?? ''}`;
}

export function obtenerFromState(state: unknown): AuthRedirectState | undefined {
  const from = (state as AuthRedirectState | null)?.from;
  return from ? { from } : undefined;
}
